(ns minorodata.app.api
  (:require [mold-http.core :refer [reg-event-http]]
            [minorodata.app.model :refer [->timezones]]))


;; =============================================================================
;; Trail
;; =============================================================================

(defn log-request [_ [type message error]]
  (let [log-message (if (some? error)
                      (str message ": " error)
                      message)]
    {:http-xhrio
     {:url    "/api/trail"
      :method :post
      :params {:type type :msg log-message}}}))

(defn log-callback [_ [error _]]
  (when (some? error)
    (js/console.error error)))

(reg-event-http
  :app.api/log
  log-request
  log-callback)


;; =============================================================================
;; Timezones
;; =============================================================================

(defn get-timezones-request [_ _]
  {:http-xhrio
   {:id  :get-timezones-request
    :url "/api/timezones"}})

(defn get-timezones-callback [_ [error results]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to fetch timezones"]}

    {:dispatch-n [[:timezones/delete]
                  [:timezones/add (->timezones results)]]}))

(reg-event-http
 :app.api/fetch-timezones
 get-timezones-request
 get-timezones-callback)
